import React, { useState } from "react";
import { Paper, Typography, IconButton, Tooltip, CircularProgress } from "@material-ui/core";
import { Refresh, BrokenImage } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(2),
    margin: theme.spacing(1, 0),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.error.light}`,
    maxWidth: 350,
    minWidth: 280,
    gap: theme.spacing(1.5)
  },
  icon: {
    fontSize: 36,
    color: theme.palette.error.main,
    flexShrink: 0
  },
  info: {
    flex: 1,
    minWidth: 0
  },
  title: {
    fontWeight: 500,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  caption: {
    color: theme.palette.error.main,
    display: "block",
    marginTop: theme.spacing(0.5)
  },
  retryButton: {
    flexShrink: 0
  }
}));

const MediaUnavailable = ({ messageId, filename, mediaType }) => {
  const classes = useStyles();
  const [retrying, setRetrying] = useState(false);

  const handleRetry = async () => {
    if (!messageId || retrying) return;
    setRetrying(true);
    try {
      await api.post(`/messages/${messageId}/retry-download`);
      toast.success("Download iniciado. Aguarde...");
    } catch (err) {
      const code = err?.response?.data?.error;
      if (code === "ERR_MEDIA_EXPIRED_ON_WHATSAPP") {
        toast.error("Esta mídia expirou no WhatsApp e não pode mais ser baixada.");
      } else {
        toast.error("Falha ao tentar baixar novamente.");
      }
    } finally {
      setRetrying(false);
    }
  };

  const label = filename || mediaType || "Arquivo";

  return (
    <Paper className={classes.container} elevation={1}>
      <BrokenImage className={classes.icon} />
      <div className={classes.info}>
        <Typography variant="body2" className={classes.title} title={label}>
          {label}
        </Typography>
        <Typography variant="caption" className={classes.caption}>
          ⚠️ Falha ao obter o arquivo do WhatsApp
        </Typography>
      </div>
      {messageId && (
        <Tooltip title="Tentar baixar novamente">
          <span>
            <IconButton
              size="small"
              onClick={handleRetry}
              disabled={retrying}
              className={classes.retryButton}
            >
              {retrying ? <CircularProgress size={20} /> : <Refresh />}
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Paper>
  );
};

export default MediaUnavailable;
